export default __webpack_public_path__ + "static/media/bg.ec326b1a.jpg";